import { Component, OnInit } from '@angular/core';
import { Routes,Router,RouterModule}  from '@angular/router';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { AppSettings } from '../appSettings';
import { CommonService } from '../services/common.service';
import { LoginService } from '../services/login.service';
declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-shopsidemenu',
  templateUrl: './shopsidemenu.component.html',
  styleUrls: ['./shopsidemenu.component.css']
})
export class ShopSidemenuComponent implements OnInit {
  model: any = {};
  userRole:any;
  FetchuserRestApiUrl: string = AppSettings.Edituser;  
  constructor(private loginService: LoginService,private CommonService: CommonService,private router: Router,private http:Http) { }

  ngOnInit() {
    this.model.usergroup=localStorage.getItem('currentUsergroup');
    this.model.id = localStorage.getItem('currentUserID');
    this.model.email = localStorage.getItem('email');
    this.model.name = localStorage.getItem('user_fname');
    this.userRole=localStorage.getItem('userRole');
    
     this.loginService.sidemenuActive();
  }

    logout(){
    this.loginService.logout();
  }


}
